/**
 * Constantes pour les modules du landing
 * Basé sur le document d'analyse et conception SyncMP
 */
import type { Module } from '../../types/landing.types'
import dashboardIcon from '../../assets/img3d/dashboard.png'
import homeIcon from '../../assets/img3d/home.png'
import calendarIcon from '../../assets/img3d/calendar.png'
import profileClientIcon from '../../assets/img3d/profileClient.png'
import fileTextIcon from '../../assets/img3d/contrat.png'
import chatIcon from '../../assets/img3d/chat.png'
import buildingIcon from '../../assets/img3d/building.png'

export const MODULES: Module[] = [
  // Première ligne
  {
    id: 'users',
    icon: '👥',
    title: 'Utilisateur & Roles',
    subtitle: 'Utilisateurs et rôles',
    color: 'users',
    status: 'success',
    notifications: 0
  },
  {
    id: 'configuration',
    icon: '⚙️',
    title: 'Configuration',
    subtitle: 'Paramètres et configuration',
    color: 'configuration',
    status: 'success',
    notifications: 0
  },
  {
    id: 'ressources',
    icon: '📦',
    title: 'Gestion des Ressources',
    subtitle: 'Ressources et stocks',
    color: 'ressources',
    status: 'success',
    notifications: 0
  },
  // Deuxième ligne
  {
    id: 'transactions',
    icon: '💳',
    title: 'Gestion des Transactions',
    subtitle: 'Transactions financières',
    color: 'transactions',
    status: 'success',
    notifications: 0
  },
  {
    id: 'couts',
    icon: '💰',
    title: 'Gestions des Coûts',
    subtitle: 'Suivi des coûts',
    color: 'couts',
    status: 'success',
    notifications: 0
  },
  {
    id: 'calcul-financier',
    icon: '📊',
    title: 'Calcul Financier',
    subtitle: 'Calculs et analyses',
    color: 'calcul-financier',
    status: 'success',
    notifications: 0
  }
] as const

// Modules TaskBar par défaut (fallback) - visiteur non authentifié
export const TASKBAR_MODULES: Module[] = [
  {
    id: 'home',
    icon: buildingIcon,
    title: 'Accueil',
    subtitle: 'Retour à l’accueil',
    color: 'dashboard',
    status: 'success',
    notifications: 0
  }
] as const

// Modules TaskBar pour les clients
export const TASKBAR_MODULES_CLIENT: Module[] = [
  {
    id: 'my-requests',
    icon: fileTextIcon,
    title: 'Mes Demandes',
    subtitle: 'Mes demandes de contact',
    color: 'my-requests',
    status: 'success',
    notifications: 0
  },
  {
    id: 'my-visits',
    icon: calendarIcon,
    title: 'Mes Visites',
    subtitle: 'Mes visites planifiées',
    color: 'my-visits',
    status: 'success',
    notifications: 0
  },
  {
    id: 'messages-client',
    icon: chatIcon,
    title: 'Messages',
    subtitle: 'Vos conversations',
    color: 'messages',
    status: 'success',
    notifications: 0
  },
  {
    id: 'dashboard-client',
    icon: dashboardIcon,
    title: 'Tableau de Bord',
    subtitle: 'Vue d\'ensemble',
    color: 'dashboard',
    status: 'success',
    notifications: 0
  }
] as const

// Modules TaskBar pour les admins
export const TASKBAR_MODULES_ADMIN: Module[] = [
  {
    id: 'contact-requests',
    icon: fileTextIcon,
    title: 'Demandes de Contact',
    subtitle: 'Gestion des demandes',
    color: 'contact-requests',
    status: 'success',
    notifications: 0
  },
  {
    id: 'calendar-visits-admin',
    icon: calendarIcon,
    title: 'Calendrier',
    subtitle: 'Planification des visites',
    color: 'calendar-visits',
    status: 'success',
    notifications: 0
  },
  {
    id: 'messages-admin',
    icon: chatIcon,
    title: 'Messages',
    subtitle: 'Messagerie temps réel',
    color: 'messages',
    status: 'success',
    notifications: 0
  }
] as const

// Modules TaskBar pour les professionnels
export const TASKBAR_MODULES_PROFESSIONAL: Module[] = [
  {
    id: 'my-properties',
    icon: homeIcon,
    title: 'Mes Propriétés',
    subtitle: 'Gestion des annonces',
    color: 'my-properties',
    status: 'success',
    notifications: 0
  },
  {
    id: 'calendar-visits',
    icon: calendarIcon,
    title: 'Calendrier Visites',
    subtitle: 'Planification des visites',
    color: 'calendar-visits',
    status: 'success',
    notifications: 0
  },
  {
    id: 'my-leads',
    icon: profileClientIcon,
    title: 'Mes Leads',
    subtitle: 'Suivi des prospects',
    color: 'my-leads',
    status: 'success',
    notifications: 0
  },
  {
    id: 'messages-pro',
    icon: chatIcon,
    title: 'Messages',
    subtitle: 'Vos conversations',
    color: 'messages',
    status: 'success',
    notifications: 0
  }
] as const

